"use client";

import { useState, useEffect, useRef } from "react";
import classNames from "classnames";

function ImageFadeIn({ src, className, ...props }) {
  const [isLoaded, setIsLoaded] = useState(false);
  const imgRef = useRef(null);

  const revealImage = () => {
    setIsLoaded(true);
  };

  useEffect(() => {
    // Check if the image is already loaded (it could be cached server side)
    if (imgRef.current && imgRef.current.complete) {
      setIsLoaded(true);
    }
  }, []);

  return (
    <img
      ref={imgRef}
      src={src}
      alt=""
      className={classNames("image-fade-in", isLoaded && "loaded", className)}
      onLoad={revealImage}
      {...props}
    />
  );
}

export default ImageFadeIn;
